import React, { FC } from "react";
import { Box, Container, Heading, Text } from "@smile2impress/components";
import { DrSmileTheme } from "@smile2impress/themes";

import { LeadForm } from "components/LeadForm";
import { UrlsConfig } from "configs/urlsConfig";
import { NestedThemeProvider } from "components/NestedThemeProvider";
import { DrSmileHeader } from "components/DrSmile/Header";

import { DrSmileUniversalFormLayoutProps } from "./DrSmileUniversalFormLayout.types";

export const DrSmileUniversalFormLayout: FC<
    DrSmileUniversalFormLayoutProps
> = ({ content }) => {
    return (
        <NestedThemeProvider theme={DrSmileTheme}>
            <Box mb={[2, 2, 4]}>
                <DrSmileHeader title={content.bannerText} />
            </Box>
            <Container>
                <Box maxW="480px" px={[3, 0]} mx="auto" mb={[10, 20]}>
                    <Heading
                        as="h1"
                        textStyle="title2"
                        textAlign="center"
                        mb={[1, 3]}
                    >
                        {content.title}
                    </Heading>
                    {content.subtitle && (
                        <Heading as="h3" textStyle="title3" mb={[3, 5]}>
                            {content.subtitle}
                        </Heading>
                    )}
                    <LeadForm
                        navigatePathname={UrlsConfig.DRSMILE_BOOKING}
                        navigateThanksPathname={
                            UrlsConfig.DRSMILE_THANKS_CONTACT
                        }
                        withPromoCode={false}
                        withTreatmentType={false}
                        isDrs
                    />
                </Box>
            </Container>
            <Container pb={10} px={["24px", "24px", 0]}>
                <Text textStyle="caption" color="text.secondary">
                    {content.bannerDisclaimer}
                </Text>
            </Container>
        </NestedThemeProvider>
    );
};
